import React, { FC, useContext, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useHistory } from 'react-router-dom';

import { useNavigationBlock } from '../../hooks/useNavigationBlock';
import useSubmitAnswerMutation from '../../hooks/useSubmitAnswerMutation';
import { ReferralNetworkQuestionnaire } from '../../referralNetworkQuestionnaire';
import { setLoading, showMessage } from '../App/app.actionCreators';
import AppContext from '../App/AppContext';
import QuestionnaireRenderErrorHandler from '../QuestionnaireRenderErrorHandler/QuestionnaireRenderErrorHandler';
import ContentLayout from '../shared/ContentLayout/ContentLayout';

const ReferralNetworkApplication: FC = () => {
  const { appDispatch } = useContext(AppContext);
  const history = useHistory();
  const [blockNavigation, setBlockNavigation] = useState(true);

  const QUESTIONNAIRE_ID = 'referral-network-application-v1.1';
  const NAVIGATION_WARNING = "Are you sure you'd like to leave? You will lose the information you've entered so far.";

  const mutation = useSubmitAnswerMutation();
  useNavigationBlock(blockNavigation, NAVIGATION_WARNING);

  const handleSubmit = async (tasks: Record<string, any>) => {
    const mutationData = {
      tasks,
      questionnaireName: QUESTIONNAIRE_ID,
    };
    setBlockNavigation(false);
    appDispatch(setLoading(true));
    try {
      await mutation.mutateAsync(mutationData);
      appDispatch(setLoading(false));
      history.push('/success');
    } catch (e: any) {
      appDispatch(setLoading(false));
      appDispatch(showMessage(e.title, e.message, false, true));
    }
  };

  return (
    <ContentLayout width="75%">
      <ErrorBoundary fallback={<QuestionnaireRenderErrorHandler />}>
        <ReferralNetworkQuestionnaire onSubmit={handleSubmit} />
      </ErrorBoundary>
    </ContentLayout>
  );
};

export default ReferralNetworkApplication;
